import { render } from "./index.vue?vue&type=template&id=525ce07e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/text/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "525ce07e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('525ce07e', __exports__)) {
    api.reload('525ce07e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=525ce07e", () => {
    api.rerender('525ce07e', render)
  })

}


export default __exports__